module.exports = __webpack_public_path__ + "media/images/icon-svg/minus-aed9260c40aea26c5d2e20a08c2b04dd.svg";